/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{equals as t}from"../../../../../core/arrayUtils.js";class s{constructor(t){this._bits=[...t]}equals(s){return t(this._bits,s.bits)}get code(){return this._code??=String.fromCharCode(...this._bits),this._code}get bits(){return this._bits}}export{s as ShaderTechniqueConfigurationKey};
